import { Size } from '../model/Size'
import { createContext } from 'react'

interface PixiAppContextType {
  resolution: Size
}

export const PixiAppContext = createContext<PixiAppContextType>({} as PixiAppContextType)
